import React, { Component } from 'react';
import '../InfluencerMap.css';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import Test from './CustomerInfluencerMapCanvasRounds/CustomerInfluencerMapCanvasRounds';
import MenuBar from './MenuBar/MenuBar';
import SceneWithDrawables from './CustomerInfluencerMapCanvasRounds/testing';

class CustomerInfluencerMap extends Component {
    constructor(props) {
        super(props);
        this.defaultParams;
        this.state = {
            color: '',
            changeColorState: false,
            arrowType: '',
            canvasHeight: 700,
            arrowPlus: 2,
            getCanvasData: false,
            getCanvasDataForBackStep: false,
            takeOffHighLightState: false,
            deleteElementState: false,
            convaWidth: null,
        };
    }

    componentWillMount() {
        let body = {
            projectId: this.props.projectId,
            type: 'influencerMap'
        }
        this.props.getInfluencerMapGroups(body);

    }
    componentWillUnmount() {
        window.removeEventListener("keydown", (e) => this.deleteElementOnKeyPress(e));
    }

    componentDidMount() {
        let width = document.getElementById('banner-contenedor').offsetWidth
        this.setState({ convaWidth: width })
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.addInfluencerMapGroupsData !== nextProps.addInfluencerMapGroupsData) {
            let body = {
                projectId: this.props.projectId,
                type: 'influencerMap'
            }
            this.props.getInfluencerMapGroups(body);
        }
        if (nextProps.getInfluencerMapGroupsData !== this.props.getInfluencerMapGroupsData) {
            if (!_.isEmpty(nextProps.getInfluencerMapGroupsData.Items)) {
                //this.defaultParams = _.extend(nextProps.getInfluencerMapGroupsData.Items[0].groups)
                this.defaultParams = nextProps.getInfluencerMapGroupsData.Items[0].groups;

            }
        }
    }

    elementInfiniteLoad() {
        return (
            <div className='col-sm-12'>
                <div className='spinner3'>
                    <div className='rect1' />
                    <div className='rect2' />
                    <div className='rect3' />
                    <div className='rect4' />
                    <div className='rect5' />
                </div>
            </div>
        );
    }

    onChangeColor = (color) => {
        this.setState({ color: color, changeColorState: true });
    }

    colorChanged = () => {
        this.setState({ changeColorState: false });
    }

    createArrow = (arrowType) => {
        this.setState({ arrowType: arrowType })
    }
    createdArrow = () => {
        this.setState({ arrowType: '' })
    }

    addArrowHeight = () => {
        this.setState({ arrowPlus: this.state.arrowPlus + 1 })
    }

    minusArrowHeight = () => {
        this.setState({ arrowPlus: this.state.arrowPlus - 1 })
    }

    defaultSize = (n) => {
        this.setState({ arrowPlus: n })
    }

    nextStep = () => {
        this.setState({ getCanvasData: true })
    }

    backStep = () => {
        this.setState({ getCanvasDataForBackStep: true })
    }

    takeOffHighLight = () => {
        this.setState({ takeOffHighLightState: true })
    }

    stepFourData = (data) => {
        _.map(data, (rect, i) => {
            const childElement = data.find(r => r.subName === rect.name);
            const elementsFromGroups = this.defaultParams.find(r => r.groupId === rect.id);

            if (childElement && elementsFromGroups) {

                if (((rect.height * rect.scaleY) > (childElement.height * childElement.scaleY)) && ((rect.width * rect.scaleX) > (childElement.width * childElement.scaleX))) {
                    //growing
                    elementsFromGroups.influenceChange = 'growing'
                }
                if (((rect.height * rect.scaleY) < (childElement.height * childElement.scaleY)) && ((rect.width * rect.scaleX) < (childElement.width * childElement.scaleX))) {
                    //shrinking
                    elementsFromGroups.influenceChange = 'shrinking'
                }
                if (((rect.height * rect.scaleY) === (childElement.height * childElement.scaleY)) && ((rect.width * rect.scaleX) === (childElement.width * childElement.scaleX))) {
                    //not changing
                    elementsFromGroups.influenceChange = 'notChanging'
                }

                let body = {
                    projectId: this.props.projectId,
                    type: 'influencerMap',
                    id: this.props.getInfluencerMapGroupsData.Items[0].id,
                    groups: this.defaultParams,
                    groupsMap: data,
                }

                this.props.editInfluencerMapGroups(body);
            }
        })

        this.props.groupStateNext();
    }
    backFromStepFour = (data) => {

        _.map(data, (rect, i) => {
            const childElement = data.find(r => r.subName === rect.name);
            const elementsFromGroups = this.defaultParams.find(r => r.groupId === rect.id);

            if (childElement && elementsFromGroups) {
                if ((rect.height > childElement.height) && (rect.width > childElement.width)) {
                    //growing
                    elementsFromGroups.influenceChange = 'growing'
                }
                if ((rect.height < childElement.height) && (rect.width < childElement.width)) {
                    //shrinking
                    elementsFromGroups.influenceChange = 'shrinking'
                }
                if ((rect.height === childElement.height) && (rect.width === childElement.width)) {
                    //not changing
                    elementsFromGroups.influenceChange = 'notChanging'
                }

                let body = {
                    projectId: this.props.projectId,
                    type: 'influencerMap',
                    id: this.props.getInfluencerMapGroupsData.Items[0].id,
                    groups: this.defaultParams,
                    groupsMap: data,
                }
                this.props.editInfluencerMapGroups(body);
            }
        })
        this.props.groupStateBack();
    }
    deleteElementOnKeyPress = (e) => {
        if (e.key === "Backspace" || e.key === "Delete") {
            this.setState({ deleteElementState: true })
        }
    }
    deleteElement = (data) => {
        if (data === 'delete') {
            this.setState({ deleteElementState: true })
        } else if (data === 'deleted') {
            this.setState({ deleteElementState: false })
        }
    }

    handleCanvasWidthChange = e => {
        this.setState(prev => {
            const res = { ...prev };
            res.convaWidth = e;
            return res;
        })
    }

    handleCanvasHeightChange = e => {
        this.setState(prev => {
            const res = { ...prev };
            res.canvasHeight = e;
            return res;
        })
    }

    handleResetCanvasHeight = () => {
        this.setState(prev => {
            const res = { ...prev };
            res.canvasHeight = 700;
            return res;
        })
    }

    handleResetCanvasWidth = () => {
        const { convaWidth } = this.state;
        let width = document.getElementById('banner-contenedor').offsetWidth;

        if (convaWidth !== width) {
            this.setState(prev => {
                const res = { ...prev };
                res.convaWidth = width;
                return res;
            })
        }
    }


    render() {
        return (
            <div className='customer-groups-content'>
                <div className='step-bar'>
                    <div className='step step-six arrow-step'>
                        <p>Step 1</p>
                    </div>
                    <div className='step step-six arrow-step '>
                        <p>Step 2</p>
                    </div>
                    <div className='step step-six arrow-step'>
                        <p>Step 3</p>
                    </div>
                    <div className='step step-six arrow-step active-step'>
                        <p>Step 4</p>
                    </div>
                    <div className='step step-six arrow-step'>
                        <p>Step 5</p>
                    </div>
                    <div className='step step-six arrow-step '>
                        <p>Result</p>
                    </div>
                </div>
                <div className='container-fluid'>
                    <div className="row">
                        <div className="col-lg-7">
                            <h5>Influencer Map</h5>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className='card'>
                                <div className='card-header'>
                                    <h5>Complete the map</h5>
                                    <span>Adjust the size of the circles, add colors, and draw arrows between them to show the strength and direction of interactions</span>
                                </div>
                                <div className='card-body'>
                                    <div className='row'>
                                        <MenuBar
                                            onChangeColor={this.onChangeColor}
                                            createArrow={this.createArrow}
                                            addArrowHeight={this.addArrowHeight}
                                            minusArrowHeight={this.minusArrowHeight}
                                            takeOffHighLight={this.takeOffHighLight}
                                            deleteElement={this.deleteElement}
                                        />

                                        <div className="canvas-card" style={{ overflow: "scroll" }}>
                                            <div className='canvas-content' id="banner-contenedor">
                                                <Test
                                                    color={this.state.color}
                                                    changeColorState={this.state.changeColorState}
                                                    handleResetCanvasHeight={this.handleResetCanvasHeight}
                                                    colorChanged={this.colorChanged}
                                                    arrowType={this.state.arrowType}
                                                    createdArrow={this.createdArrow}
                                                    handleCanvasHeightChange={this.handleCanvasHeightChange}
                                                    arrowPlus={this.state.arrowPlus}
                                                    canvasHeight={this.state.canvasHeight}
                                                    defaultSize={this.defaultSize}
                                                    getCanvasData={this.state.getCanvasData}
                                                    getCanvasDataForBackStep={this.state.getCanvasDataForBackStep}
                                                    getInfluencerMapGroupsData={this.props.getInfluencerMapGroupsData}
                                                    stepFourData={this.stepFourData}
                                                    backFromStepFour={this.backFromStepFour}
                                                    takeOffHighLightState={this.state.takeOffHighLightState}
                                                    deleteElement={this.deleteElement}
                                                    deleteElementState={this.state.deleteElementState}
                                                    convaWidth={this.state.convaWidth}
                                                    setCanvasWidth={this.handleCanvasWidthChange}
                                                    handleResetCanvasWidth={this.handleResetCanvasWidth}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='card'>
                                <div className='card-body'>
                                    <div className='btn btn-success' onClick={this.nextStep}
                                    >Next</div>
                                    <div onClick={this.backStep} className='btn empty-btn default'> Back  </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default (CustomerInfluencerMap);



// WEBPACK FOOTER //
// ./src/components/InfluencerMap/CustomerInfluencerMap/CustomerInfluencerMap.jsx